<template>
  <!-- 产品详情 -->
  <div class="productDetail">
    <!-- 头部 -->
    <headerNav activeIndex="productCenter" @setBanner="setBanner"></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="maxWidth pc" style="margin-top:110px;">
      <div
        style="
          border-bottom: 1px solid #719468;
          padding: 14px 0;
          line-height: 23px;
          display: flex;
        "
      >
        <div style="font-size: 23px" class="clickBtn1" @click="goHome">
          首页
        </div>
        <div style="font-size: 18px; margin: 0 12px">-</div>
        <div style="font-size: 18px" class="clickBtn1" @click="goback">
          明星原料
        </div>
        <div style="font-size: 18px; margin: 0 12px">-</div>
        <div style="font-size: 18px">
          {{ productInfo.name }}
        </div>
      </div>
      <div style="padding:45px 200px 90px;" class="ql-editor" v-html = "productInfo.content">
      </div>
    </div>
    <div class="mobile" style="padding:0.2rem 0.1rem;">
      <div style="font-size:22px;text-align:center;margin-bottom:0.2rem;color:#719468;" v-html="productInfo.name"></div>
      <div class="editor" v-html = "productInfo.content"></div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import bannerNav from "@/components/banner/index";
import footerNav from "@/components/footerNav/index";
import { getProductById } from '@/api/product'

export default {
  name: "productDetail",
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: "",
      }, //轮播图
      mobile: false,
      productInfo:{}//产品详情
    };
  },
  mounted() {
    this.getProduct()
  },
  methods: {
    setBanner(url,mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      }
    },
    getProduct(){
      getProductById({id:this.$route.params.id}).then(response => {
        if(response.data !== null){
          this.productInfo = response.data
          if(this.isMobile() === true){
            this.postMessage(
                this.productInfo.name,
                this.productInfo.description,
                window.location.href,
                this.getUrlPrefix(this.productInfo.images)
              );
              
            this.productInfo.name = this.productInfo.name.replace("（", "<br>（");
            this.productInfo.name = this.productInfo.name.replace("(", "<br>(");
          }
        }else{
          this.$router.replace({name:'404'})
        }
      }).catch(()=>{
        this.$router.replace({name:'500'})
      })
    },
    goback() {
      this.$router.back();
    },
    goHome() {
      this.$router.push({ name: "home" });
    },
  },
};
</script>

<style lang="scss">
.productDetail {
  .maxWidth {
    width: 1067px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/productCenter/detail.vue